import {getBackendAssetUrl, getDateFromIsoString} from '@shared/api';
import {createTranslationDict} from '@shared/helpers';
import {getLocalizedText} from '@shared/utils';
import {Category, SubCategory} from '../../category';
import {Topic} from '../types';
import {TopicOnBackend} from './backendTypes';

const mapSubCategoryFromBackend = (subCategory: unknown): SubCategory => {
  const subCategoryObject =
    subCategory &&
    typeof subCategory === 'object' &&
    !Array.isArray(subCategory)
      ? (subCategory as Record<string, unknown>)
      : {};

  const id =
    typeof subCategoryObject.id === 'string' && subCategoryObject.id
      ? subCategoryObject.id
      : typeof subCategoryObject.slug === 'string'
        ? subCategoryObject.slug
        : '';

  const slug =
    typeof subCategoryObject.slug === 'string' && subCategoryObject.slug
      ? subCategoryObject.slug
      : id;

  return {
    id,
    name: getLocalizedText(subCategoryObject.name),
    slug,
  };
};

export const mapTopicFromBackend = (
  {
    id,
    topic_id,
    topic_slug,
    name,
    short_name,
    logo_url,
    banner_url,
    stream_url,
    category_banner_url,
    category_logo_url,
    category_name,
    category_slug,
    subcategories,
    geo_slugs,
    start_date,
    end_date,
    is_live,
    is_favorite,
    auto_publish_enabled,
    trading_volume,
    published_events_count,
    created_at,
  }: TopicOnBackend,
  categories?: Category[],
): Topic => {
  const mappedName = getLocalizedText(name);
  const mappedNameTranslations = createTranslationDict(name);
  const mappedShortName = getLocalizedText(short_name);
  const mappedSubCategories = (subcategories ?? []).map(subCategory =>
    mapSubCategoryFromBackend(subCategory),
  );
  const mappedCategoryName = getLocalizedText(category_name);
  const category = mappedCategoryName
    ? (categories?.find(cat => cat.name === mappedCategoryName) ?? null)
    : null;

  return {
    id,
    topicId: topic_id ?? topic_slug ?? id,
    name: mappedName,
    nameTranslations: mappedNameTranslations,
    shortName: mappedShortName || mappedName,
    logoUrl: getBackendAssetUrl(
      logo_url ?? category_logo_url ?? banner_url ?? category_banner_url ?? '',
    ),
    bannerUrl: getBackendAssetUrl(banner_url ?? category_banner_url ?? ''),
    streamUrl: stream_url ?? null,
    categoryLogoUrl: getBackendAssetUrl(category_logo_url ?? ''),
    categoryName: mappedCategoryName,
    categorySlug: category_slug ?? null,
    category,
    subCategories: mappedSubCategories,
    geoSlugs: (geo_slugs ?? []).filter(
      (g): g is string => typeof g === 'string',
    ),
    startDate: getDateFromIsoString(start_date),
    endDate: end_date ? getDateFromIsoString(end_date) : null,
    isLive: is_live ?? false,
    isFavorite: is_favorite ?? false,
    autoPublishEnabled: auto_publish_enabled ?? false,
    tradingVolume: trading_volume ?? 0,
    publishedEventsCount: published_events_count ?? null,
    createdAt: created_at ? getDateFromIsoString(created_at) : null,
  };
};
